export default {
  root: {
    color: '#4800F8',
  },
  menu: {
    mt: 1.4,

    '& .MuiPaper-root': {
      width: 163,
      maxHeight: 300,
      overflowY: 'auto',
      boxShadow: '0px 2px 20px 0px #00000014',
      borderRadius: 1,
    },
    '& .MuiDivider-root': {
      mt: 1.3,
      mb: 1.3,
    },
  },
  menuItem: {
    display: 'flex',
    mx: 1,
    '& svg': {
      mr: 0.5,
    },
    '& .MuiTypography-root': {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '18px',
      color: '#4800F8',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
};
